"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsSwiperResizeListener = exports.ResizingMessage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StepsSwiperResizeListener = exports.StepsSwiperResizeListener = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepsSwiperResizeListener",
  componentId: "sc-1merd0t-0"
})(["height:100%;left:0;position:absolute;top:0;width:100%;"]);
var ResizingMessage = exports.ResizingMessage = _styledComponents["default"].div.withConfig({
  displayName: "styles__ResizingMessage",
  componentId: "sc-1merd0t-1"
})(["left:50%;opacity:0.3;position:absolute;top:50%;transform:translate(-50%,-50%);"]);
//# sourceMappingURL=styles.js.map